import { useState, useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function EventsPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('全部');
  const [selectedStatus, setSelectedStatus] = useState('全部');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const categories = ['全部', '錦標賽', '培訓', '聯賽', '友誼賽'];
  const statuses = ['全部', '報名中', '即將開始', '籌備中', '已結束'];

  const allEvents = [
    {
      title: '2026 二月份聯會乒乓球友誼賽',
      date: '2026年2月1日',
      location: '香港體育館',
      category: '錦標賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '報名中',
      participants: 128,
      fee: 'HK$500'
    },
    {
      title: '青少年乒乓球訓練營',
      date: '2024年5月1-5日',
      location: '深圳訓練中心',
      category: '培訓',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '即將開始',
      participants: 60,
      fee: 'HK$1,200'
    },
    {
      title: '企業乒乓球聯賽',
      date: '2024年6月10日',
      location: '廣州體育中心',
      category: '聯賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '籌備中',
      participants: 96,
      fee: 'HK$800'
    },
    {
      title: '國際友誼賽',
      date: '2024年7月20-22日',
      location: '澳門綜合體育館',
      category: '友誼賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '籌備中',
      participants: 80,
      fee: 'HK$600'
    },
    {
      title: '長者乒乓球同樂日',
      date: '2024年8月15日',
      location: '香港社區中心',
      category: '友誼賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '報名中',
      description: '專為長者設計的乒乓球活動，促進健康生活',
      participants: '不限',
      fee: '免費'
    },
    {
      title: '女子乒乓球公開賽',
      date: '2024年9月8日',
      location: '深圳體育館',
      category: '錦標賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '籌備中',
      description: '展現女性運動員風采的專業乒乓球賽事',
      participants: '預計100人',
      fee: 'HK$400'
    },
    {
      title: '親子乒乓球體驗日',
      date: '2024年10月1日',
      location: '廣州體育中心',
      category: '培訓',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '報名中',
      description: '親子共同參與，培養孩子對乒乓球的興趣',
      participants: '限額30組',
      fee: 'HK$200/組'
    },
    {
      title: '大學生乒乓球聯賽',
      date: '2024年11月12-14日',
      location: '香港大學體育館',
      category: '聯賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '籌備中',
      description: '大灣區各大學乒乓球隊的年度盛事',
      participants: '15支隊伍',
      fee: 'HK$1,500/隊'
    },
    {
      title: '冬季乒乓球錦標賽',
      date: '2024年12月20日',
      location: '澳門體育館',
      category: '錦標賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/873196f34a6ad020a4f144b348146440.jpeg',
      status: '已結束',
      description: '年度壓軸錦標賽，決出年度總冠軍',
      participants: '180人',
      fee: 'HK$600'
    }
  ];

  const filteredEvents = allEvents.filter(event => {
    const categoryMatch = selectedCategory === '全部' || event.category === selectedCategory;
    const statusMatch = selectedStatus === '全部' || event.status === selectedStatus;
    return categoryMatch && statusMatch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Header isScrolled={isScrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-6xl md:text-7xl font-black text-gray-900 mb-6">
              活動計劃
            </h1>
            <div className="w-32 h-2 bg-emerald-600 mx-auto mb-8"></div>
            <p className="text-2xl text-gray-600 max-w-3xl mx-auto mb-12">
              精彩賽事不容錯過，立即報名參加
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-6">
            {/* Category Filter */}
            <div className="flex-1">
              <label className="block text-sm font-bold text-gray-700 mb-3">
                活動類別
              </label>
              <div className="flex flex-wrap gap-2">
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-5 py-2.5 rounded-full text-sm font-bold transition-all whitespace-nowrap cursor-pointer ${
                      selectedCategory === category
                        ? 'bg-emerald-600 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Status Filter */}
            <div className="flex-1">
              <label className="block text-sm font-bold text-gray-700 mb-3">
                活動狀態
              </label>
              <div className="flex flex-wrap gap-2">
                {statuses.map((status) => (
                  <button
                    key={status}
                    onClick={() => setSelectedStatus(status)}
                    className={`px-5 py-2.5 rounded-full text-sm font-bold transition-all whitespace-nowrap cursor-pointer ${
                      selectedStatus === status
                        ? 'bg-emerald-600 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {status}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-6 text-center">
            <p className="text-gray-600">
              找到 <span className="font-bold text-emerald-600">{filteredEvents.length}</span> 個活動
            </p>
          </div>
        </div>
      </section>

      {/* Events Grid */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredEvents.map((event, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100"
              >
                <div className="relative h-56 w-full overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 right-4">
                    <span className={`px-4 py-2 text-white text-sm font-bold rounded-full shadow-lg ${
                      event.status === '報名中' ? 'bg-emerald-600' :
                      event.status === '即將開始' ? 'bg-orange-500' :
                      event.status === '籌備中' ? 'bg-blue-500' :
                      'bg-gray-500'
                    }`}>
                      {event.status}
                    </span>
                  </div>
                  <div className="absolute top-4 left-4">
                    <span className="px-4 py-2 bg-white/95 text-gray-900 text-sm font-bold rounded-full shadow-lg">
                      {event.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                    {event.title}
                  </h3>
                  
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {event.description}
                  </p>

                  <div className="space-y-2 mb-4">
                    <div className="flex items-center text-gray-600 text-sm">
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-calendar-line text-emerald-600"></i>
                      </div>
                      <span>{event.date}</span>
                    </div>
                    <div className="flex items-center text-gray-600 text-sm">
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-map-pin-line text-emerald-600"></i>
                      </div>
                      <span>{event.location}</span>
                    </div>
                    <div className="flex items-center text-gray-600 text-sm">
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-group-line text-emerald-600"></i>
                      </div>
                      <span>{event.participants}</span>
                    </div>
                    <div className="flex items-center text-gray-600 text-sm">
                      <div className="w-5 h-5 flex items-center justify-center mr-2">
                        <i className="ri-price-tag-3-line text-emerald-600"></i>
                      </div>
                      <span className="font-bold text-emerald-600">{event.fee}</span>
                    </div>
                  </div>

                  <button className="w-full px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
                    <i className="ri-file-list-line mr-2"></i>
                    查看詳情
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredEvents.length === 0 && (
            <div className="text-center py-20">
              <div className="w-24 h-24 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-6">
                <i className="ri-calendar-close-line text-5xl text-gray-400"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                暫無符合條件的活動
              </h3>
              <p className="text-gray-600 mb-6">
                請嘗試調整篩選條件
              </p>
              <button
                onClick={() => {
                  setSelectedCategory('全部');
                  setSelectedStatus('全部');
                }}
                className="px-8 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                重置篩選
              </button>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-emerald-600 to-teal-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            想了解更多活動資訊？
          </h2>
          <p className="text-xl text-white/90 mb-10">
            訂閱我們的電子報，第一時間獲取最新賽事通知
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#events"
              className="inline-block px-10 py-4 bg-white hover:bg-gray-100 text-emerald-600 text-lg font-bold rounded-full transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              訂閱電子報
            </a>
            <a
              href="#contact"
              className="inline-block px-10 py-4 bg-transparent hover:bg-white/10 text-white text-lg font-bold rounded-full border-2 border-white transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              聯絡我們
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
